import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  toggleShouldChargeBranchFee,
  toggleShouldChargeVesselCountyFee,
  toggleLockedCountyFee,
} from '../redux/modules/registration';

class LockedFees extends Component {
  getLockButton() {
    const { isLocked, toggleLockedCountyFee } = this.props;
    const click = () => toggleLockedCountyFee();
    if (!isLocked) {
      return <button onClick={click} className="LockBtn LockBtn--unlocked"><i className="fa fa-unlock-alt LockBtn-icon" aria-hidden="true"></i> <span className="LockBtn-text">unlocked</span></button>;
    }
    return <button onClick={click} className="LockBtn LockBtn--locked"><i className="fa fa-lock LockBtn-icon" aria-hidden="true"></i> <span className="LockBtn-text">locked</span></button>;
  }

  render() {
    const { shouldChargeBranchFee, shouldChargeVesselCountyFees, isLocked } = this.props;

    return (
      <div className="Box">

        <div className="LockFee-box">
          <input
            type="checkbox"
            disabled={isLocked}
            checked={shouldChargeBranchFee}
            data-tooltip="Resets page then checks/unchecks branch fees"
            id="chargebranchfee"
            onChange={() => this.props.toggleShouldChargeBranchFee()}
          />
          <label className="LockFee-label" htmlFor="chargebranchfee">County Branch Fee</label>
        </div>

        <div className="LockFee-box">
          <input
            type="checkbox"
            disabled={isLocked}
            checked={shouldChargeVesselCountyFees}
            data-tooltip="Resets page then checks/unchecks Vessel County Fees"
            id="VesselCountyFees"
            onChange={() => this.props.toggleShouldChargeVesselCountyFee()}
          />
          <label className="LockFee-label" htmlFor="VesselCountyFees">County Vessel Fees</label>

          <div className="LockFee-box">
            {this.getLockButton()}
          </div>

        </div>
      </div>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    shouldChargeBranchFee: state.registration.shouldChargeBranchFee,
    shouldChargeVesselCountyFees: state.registration.shouldChargeVesselCountyFees,
    isLocked: state.registration.isLocked,
  };
};

export default connect(mapStateToProps, {
  toggleShouldChargeBranchFee,
  toggleShouldChargeVesselCountyFee,
  toggleLockedCountyFee,
})(LockedFees);



// WEBPACK FOOTER //
// ./src/containers/LockedFees.js